import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'underscore';
import { UserData } from '../shared/service/UserService';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AdvanceVectoringService {


  private apiUrl: string;
  private header;
  private headerAppJSON;

  constructor(private http: HttpClient) {
    this.apiUrl = UserData.backend_url + '/v1';
    this.header = this.getHeader();
    this.headerAppJSON = this.getHeaderAppJSON();
  }

  public getHeader() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': authorizationString
      })
    };
    return httpOptions;
  }

  public getHeaderAppJSON() {
    let authorizationString = "Bearer " + UserData.token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': authorizationString,
        'Content-Type': 'application/json'
      })
    };
    return httpOptions;
  }


  getSessionCountData(day, game, type, startDate, endDate) {
    let url = `/analytics/advVectoringMissionAnalyticsUsageCount?${day}=${day}&missionType=${game}`;
    if(type == 'range'){
      url = `/analytics/advVectoringMissionAnalyticsUsageCount?fromDate=${startDate}&toDate=${endDate}&missionType=${game}`
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getSessionCountDataBasic(day, game, type, startDate, endDate){
    let url = `/analytics/basicVectoringLessonAnalyticsUsageCount?${day}=${day}&lessonType=${game}`;
    if(type == 'range') {
      url = `/analytics/basicVectoringLessonAnalyticsUsageCount?fromDate=${startDate}&toDate=${endDate}&lessonType=${game}`;
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getPerticularMissionData(day, game, type, startDate, endDate) {
    let url = `/analytics/advVectoringMissionAnalyticsUsage?${day}=${day}&missionType=${game}`;
    if (type == 'range') {
      url = `/analytics/advVectoringMissionAnalyticsUsage?fromDate=${startDate}&toDate=${endDate}&missionType=${game}`
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getPerticularMissionDataBasic(day, game, type, startDate, endDate){
    let url = `/analytics/basicVectoringLessonAnalyticsUsage?${day}=${day}&lessonType=${game}`;
    if (type == 'range') {
      url = `/analytics/basicVectoringLessonAnalyticsUsage?fromDate=${startDate}&toDate=${endDate}&lessonType=${game}`
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getGraphDetails(day, missionType, usageType, type, startDate, endDate) {
    let url = `/analytics/advVectoringMissionAnalyticsUsageGraph?${day}=${day}&missionType=${missionType}&selectedUsageType=${usageType}`;
    if (type == 'range') {
      url = `/analytics/advVectoringMissionAnalyticsUsageGraph?fromDate=${startDate}&toDate=${endDate}&missionType=${missionType}&selectedUsageType=${usageType}`
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  getGraphDetailsBasic(day, missionType, usageType, type, startDate, endDate) {
    let url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?${day}=${day}&lessonType=${missionType}&selectedUsageType=${usageType}`;
    if (type == 'range') {
      url = `/analytics/basicVectoringLessonAnalyticsUsageGraph?fromDate=${startDate}&toDate=${endDate}&lessonType=${missionType}&selectedUsageType=${usageType}`
    }
    return this.http.get(this.apiUrl + url, this.header);
  }

  public getcsvDataForGraph(type, usageType, mission, startDate, endDate): Observable<Blob> {
    let url = this.apiUrl + `/analytics/downloadAdvVectoringMissionAnalyticsUsageGraph?${type}=${type}&missionType=${mission}&selectedUsageType=${usageType}`;
    if(type == 'range'){
      url = this.apiUrl + `/analytics/downloadAdvVectoringMissionAnalyticsUsageGraph?fromDate=${startDate}&toDate=${endDate}&missionType=${mission}&selectedUsageType=${usageType}`;
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getCsvDataForMission(type, mission,startDate, endDate): Observable<Blob> {
    let url = this.apiUrl + `/analytics/downloadAdvVectoringMissionAnalyticsUsage?${type}=${type}&missionType=${mission}`;
    if(type == 'range'){
      url = this.apiUrl + `/analytics/downloadAdvVectoringMissionAnalyticsUsage?fromDate=${startDate}&toDate=${endDate}&missionType=${mission}`;
    }
    return this.http.get(url, { responseType: "blob" });
  }

  public getcsvDataForGraphBasic(type, usageType,lesson, startDate, endDate): Observable<Blob> {
    let url = this.apiUrl + `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?${type}=${type}&lessonType=${lesson}&selectedUsageType=${usageType}`;
    if(type == 'range'){ // SG-7046
      url = this.apiUrl + `/analytics/downloadBasicVectoringLessonAnalyticsUsageGraph?fromDate=${startDate}&toDate=${endDate}&lessonType=${lesson}&selectedUsageType=${usageType}`;
    }
    return this.http.get(url, { responseType: "blob" });
  }
  public getCsvDataForMissionBasic(type,lesson, startDate, endDate): Observable<Blob> {
    let url = this.apiUrl + `/analytics/downloadBasicVectoringLessonAnalyticsUsage?${type}=${type}&lessonType=${lesson}`;
    if(type == 'range'){// SG-7046
      url = this.apiUrl + `/analytics/downloadBasicVectoringLessonAnalyticsUsage?fromDate=${startDate}&toDate=${endDate}&lessonType=${lesson}`;
    }
    return this.http.get(url, { responseType: "blob" });
  }
}
